module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-regular.329ae1c3.ttf";